import Vue from "vue";
import axios from "axios";
import qs from "qs";
import { Toast } from "vant";
import { getUrlHost, X_BUSINESSLINE_ID, X_BRAND } from "../saasConfig/index";
axios.defaults.headers.common["X-Businessline-Id"] = X_BUSINESSLINE_ID;
import { getUrlParams } from "@/utils";

// 创建一个 axios 实例
let baseURL = `https://api.${getUrlHost()}.com`;
const axiosInstance = axios.create({
  withCredentials: true,
  timeout: 300000,
  baseURL,
});
// 请求拦截器
axiosInstance.interceptors.request.use(
  (config) => {
    // 检查是否为免登录模式，如果是则替换 campaignv2 接口的域名
    if (
      Vue.prototype.$isLoginFree &&
      config.url &&
      config.url.includes("/campaignv2")
    ) {
      // 替换域名
      config.baseURL = config.baseURL.replace(
        `api.${getUrlHost()}.com`,
        "app.xesv5.com"
      );
      const stuId = getUrlParams()?.stuId;
      if (stuId) {
        config.headers["X-User-Id"] = stuId;
      }
    }

    if (config.method === "post") {
      if (config.data === undefined) {
        config.data = {};
      }
      //   if (
      //     config.url !== "/porder/v1/tool/idencode" &&
      //     config.url !== "/campaignv2/check"
      //   ) {
      //     // 特殊处理一下特殊post请求的参数
      //     config.data = qs.stringify({
      //       ...config.data,
      //       brand: X_BRAND,
      //       "X-Businessline-Id": X_BUSINESSLINE_ID,
      //     });
      //   } else {

      //   }
      config.data = {
        ...config.data,
        brand: X_BRAND,
        "X-Businessline-Id": X_BUSINESSLINE_ID,
      };
    } else if (config.method === "get") {
      const params = qs.parse(config.params);
      config.params = {
        ...params,
        brand: X_BRAND,
        "X-Businessline-Id": X_BUSINESSLINE_ID,
        _: new Date().getTime(),
      };
    }
    return config;
  },
  (error) => {
    // 处理请求错误
    return Promise.reject(error);
  }
);
// 响应拦截器
axiosInstance.interceptors.response.use(
  (response) => {
    // 处理响应数据
    const { stat, msg, data = {} } = response.data || {};
    console.log("response--------", response);
    if (response.status === 200 && stat === 1) {
      // 请求成功
      return data;
    } else {
      if (response.data.code === 9) {
        window.location.href = `https://login.${getUrlHost()}.com?from=touch&redirect_url=${encodeURIComponent(
          window.location.href
        )}`;
        return;
      }
      Toast(msg || "请求失败请重试");
      // 请求失败
      return Promise.reject(response.data);
    }
  },
  (error) => {
    Toast("请求失败请重试");
    // 处理响应错误
    return Promise.reject(error);
  }
);

export default axiosInstance;
